<h2 class="form-title">{{ titleName }}</h2>
<div *ngIf="loading">
  <app-loading-indicator></app-loading-indicator>
</div>
<form (ngSubmit)="onSubmit()" id="addSkillAreaForm">
  <div class="control" id="addSkillAreaName">
    <label for="name">Name</label>
    <input
      class="form-control"
      type="text"
      id="name"
      name="name"
      [(ngModel)]="enteredName"
    />
  </div>

  <div class="actions d-flex justify-content-between">
    <button class="w-100 mx-2" type="button" (click)="onCancel()">
      Cancel
    </button>
    <button class="w-100 mx-2" type="submit" id="saveSkillAreaButton">
      {{ actionName }}
    </button>
  </div>
</form>
